<template>
  <b-card class="mt-5">
       <b-row class="my-2 mb-4">
         <b-col>
           <h3 class="text-center">
             Capturar recolección
           </h3>
         </b-col>
       </b-row>
       <div
             class="mt-2 row bg-white  rounded mb-2 "
                data-app
              >
                <b-col class="col-12 col-sm-12">
                  <b-form-group
                      label="Cultivo"
                    >
                       <vk-select
                        :options="cultivos"
                        placeholder="Cultivo"
                        @input="selectCultivo($event)"
                        label="descripcion"
                        :item-value="'id'"
                        v-model="cultivo"
                        solo
                      ></vk-select>
                    </b-form-group>
                </b-col>

                <div class="col-6 col-sm-6">
                  <b-form-group
                      label="Cuadro"
                      label-for="cuadroInput"
                    >
                       <vk-select
                        inputId="cuadro_select"
                        :options="cuadros"
                        placeholder="Cuadro"
                        @input="selectCuadro($event)"
                        label="clave_cuadro"
                        v-model="cuadro"
                        :item-value="'id'"
                        solo
                        :disabled='cuadros.length <= 0'
                      ></vk-select>
                    </b-form-group>
                 
                </div>

                <div class="col-6 col-sm-6">
                  <b-form-group
                      label="Variedad"
                      label-for="disabledInput"
                    >
                      <b-form-input
                        id="disabledInput"
                        v-model="variedadText"
                        disabled
                      />
                    </b-form-group>
                </div>

                <b-col class="col-6 col-sm-6">
                  <b-form-group
                      label="Contratista"
                    >
                       <vk-select
                        :options="contratistas"
                        placeholder="Contratista"
                        @input="selectContratista($event)"
                        label="nombre_full"
                        :item-value="'id'"
                        v-model="contratista"
                        solo
                      ></vk-select>
                    </b-form-group>
                </b-col>

                <b-col class="col-6 col-sm-6">
                  <b-form-group
                      label="Cuadrillero"
                    >
                       <vk-select
                        :options="cuadrilleros"
                        placeholder="Cuadrillero"
                        @input="selectCuadrillero($event)"
                        label="nombre_full"
                        :item-value="'id'"
                        v-model="cuadrillero"
                        solo
                        :disabled='cuadrilleros.length <= 0'
                      ></vk-select>
                    </b-form-group>
                </b-col>

                <b-col class="col-6 col-sm-6">
                  <b-form-group
                      label="Equipo"
                    >
                       <vk-select
                        :options="equipos"
                        placeholder="Equipo"
                        @input="selectEquipo($event)"
                        label="descripcion"
                        :item-value="'id'"
                        :disabled='equipos.length <= 0'
                        solo
                         v-model="equipo"
                      ></vk-select>
                    </b-form-group>
                </b-col>

                <b-col class="col-6 col-sm-6">
                  <b-form-group
                      label="Matriz de materiales"
                    >
                       <vk-select
                        :options="matriz_materiales"
                        placeholder="Matriz de materiales"
                        @input="selectMaterial($event)"
                        label="descripcion"
                        :item-value="'id'"
                        v-model="palletTipo"
                        :disabled='matriz_materiales.length <= 0'
                        solo
                      ></vk-select>
                    </b-form-group>
                </b-col>

                <div class="col-6 col-sm-6">
                  <b-form-group
                      label="Cantidad"
                    >
                      <b-form-input
                        v-model="cantidad"
                        type='number'
                      />
                    </b-form-group>
                </div>

                <b-col class="col-6 col-sm-6">
                  <b-form-group
                      label="Camiones"
                    >
                       <vk-select
                        :options="camiones"
                        placeholder="Camión"
                        @input="selectCamion($event)"
                        label="numero"
                        :item-value="'id'"
                        v-model="camion"
                        solo
                      ></vk-select>
                    </b-form-group>
                </b-col>
      </div> 

      <b-row class="mt-4">
        <b-col>
          <b-button @click="store()" class="w-100" variant="success">
               Guardar
          </b-button>
          <span v-if="btnC != true && sh_errors" class="text-danger text-center w-100">
            {{btnC}}
          </span>
        </b-col>
      </b-row>


    <!--  <b-row class='mt-4'>
        <b-col>
          <b-button @click=" probarConexion()" class="w-100">
            Probar Conexión
          </b-button>
        </b-col>
      </b-row> -->
  </b-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/core/services/api.service"; 
const axios = require('axios');
//import MixedWidget1 from "@/view/content/widgets/mixed/Widget1.vue";
/*import AdvancedTableWidget2 from "@/view/content/widgets/advance-table/Widget2.vue";
import MixedWidget1 from "@/view/content/widgets/mixed/Widget1.vue";
import ListWidget1 from "@/view/content/widgets/list/Widget1.vue";
import ListWidget3 from "@/view/content/widgets/list/Widget3.vue";
import ListWidget4 from "@/view/content/widgets/list/Widget4.vue";
import ListWidget8 from "@/view/content/widgets/list/Widget8.vue";
import ListWidget9 from "@/view/content/widgets/list/Widget9.vue";
import StatsWidget7 from "@/view/content/widgets/stats/Widget7.vue";
import StatsWidget12 from "@/view/content/widgets/stats/Widget12.vue";*/

export default {
  name: "dashboard",
  components: {
    /* AdvancedTable
   Widget2,
    MixedWidget1,
    ListWidget1,
    ListWidget3,
    ListWidget4,
    ListWidget8,
    ListWidget9,
    StatsWidget7,
    StatsWidget12 */
  },
  data: () => ({
    contratistas:[],
    cuadros:[],
    matriz_materiales:[],
    cuadrilleros:[],
    equipos:[],
    cultivos:[],
    cultivo:null,
    cuadrilleroId: null,
    cuadrillero:null,
    equipoId:null,
    equipo:null,
    contratistaId : null,
    contratista : null,
    variedadText:null,
    variedadId:null,
    cuadroId:null,
    cuadro:null,
    palletTipoId:null,
    palletTipo:null,
    cantidad:null,
    camiones:[],
    camionId:null,
    cultivoId:null,
    camion:null,
    sh_errors:false
  }),
  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapState({
      users: state => state.users.users,
      data : state => state.asistencias.data
    }),
    btnC(){
      if(this.contratistaId === null){
          return "Debes seleccionar un contratista"
      }else if(this.cuadrilleroId === null){
          return "Debes seleccionar un cuadrillero"
      }else if(this.equipoId === null){
          return "Debes seleccionar un equipo"
      }else if(this.cuadroId === null){
          return "Debes seleccionar un cuadro"
      }else if(this.palletTipoId === null){
           return "Debes seleccionar una matriz de materiales"
      }else if(this.cantidad === null || this.cantidad <= 0 ){
          return "Debes agregar una cantidad mayor a 0"
      }
      else if(this.camionId === null ){
          return "Debes seleccionar un camión"
      }
      return true
    }
  },
  created() {
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }])
    if(this.data != null){
      this.contratistas = this.data.contratistas
      this.cultivos = this.data.cultivos
     // this.matriz_materiales = this.data.matriz_materiales
      this.camiones = this.data.camiones
    }
    document.getElementById("cuadro_select").setAttribute("type", "number")
  },
  watch:{
    data(){
        this.contratistas = this.data.contratistas
        this.cultivos = this.data.cultivos
       // this.matriz_materiales = this.data.matriz_materiales
        this.camiones = this.data.camiones
    }
  },
  methods: {
    
    probarConexion(){
        axios.get('https://appagricactus.xyz/monday/listarUsuarios')
        .then(function () {
           this.$toasted.show("Conexion exitosa", {
            duration: 1500,
            type: "success"
          });
        }).catch( () => {
          this.$toasted.show("Error", {
            duration: 1500,
            type: "error"
          });
        })
    },
    store(){
      if(this.btnC != true){
        this.sh_errors = true
        return
      }else{
        this.$store.dispatch("storeRecoleccion", { 
          cuadrilleroId : this.cuadrilleroId,
          equipoId: this.equipoId,
          contratistaId : this.contratistaId,
          variedadId: this.variedadId, 
          cuadroId : this.cuadroId, 
          palletTipoId : this.palletTipoId , 
          cantidad : this.cantidad,
          camionId : this.camionId,
          cultivoId : this.cultivoId
        })
        this.$toasted.show("Se guardo recolección correctamente." , {
          duration: 1500,
          type: "success"
        });
      //  this.selectCuadro(this.cuadroId)
        this.cantidad = null
        this.palletTipoId = null
        //this.selectContratista(this.contratistaId)
        this.sh_errors = false
        this.eqipoId = null
       // this.cuadrillero = null
        this.equipo = null
      //  this.contratista = null
       // this.matriz_materiales = []
      //  this.cuadro = null
        this.palletTipo = null
      //  this.camionId = null
      //  this.camion = null
      //  this.cultivo = null
      //  this.cultivoId = null
      }
    },
    selectCultivo(e){
      this.cuadros = []
      this.cuadroId = null
      this.variedadId = null
      this.cuadro = null
      this.palletTipo = null
      this.variedadText = null
      this.palletTipoId = null
      this.cultivoId = null
      if( e != null){
        let cuadros = []
        e.variedads.map(x => {
          x.cuadros.map(c =>{
             cuadros.push(c)
          })
        })
      //  this.palletTipo = e.pallet_tipo
        this.cultivoId = e.id
        let matriz_materiales = [...e.pallet_tipos]
        let addM = []
        matriz_materiales.map(x => {
          addM.push(
            {
              id: x.id,
              descripcion: x.id + ' - ' + x.descripcion
            }
          )
        })
        this.matriz_materiales = addM.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
     //   this.palletTipoId = e.pallet_tipo.id
        this.cuadros = cuadros.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i).sort((a,b) => (a.clave_cuadro > b.clave_cuadro) ? 1 : ((b.clave_cuadro > a.clave_cuadro) ? -1 : 0))
      }
    },
    selectCuadro(e){
      this.variedadText = null
      this.variedadId = null
      this.cuadroId = null
      if( e != null){
        this.variedadText = e.variedad.descripcion
        this.variedadId = e.variedad.id
        this.cuadroId = e.id
      }
    },
    selectCamion(e){
       this.camionId = null
      if( e != null){
        this.camionId = e.id
      }
    },
    selectMaterial(e){
       this.palletTipoId = null
      if( e != null){
        this.palletTipoId = e.id
      }
    },
    selectContratista(e){
      this.cuadrilleros = []
      this.equipos = []
      this.contratistaId = null
      this.cuadrilleroId = null
      this.cuadrillero = null
      this.equipo = null
      this.equipoId = null
      if( e != null){
        let usuarios = []
        e.cuadrilla_contratista.map(x => {
             usuarios.push(x.cuadrillero)
        })
       // let cuadrilleros = []
       /* usuarios.map(x => {
           let exists = false 
           cuadrilleros.map(y => {
             if(y.id === x.id){
               exists = true
               y.equipo.push(x.equipo[0])
             }
           })
           if(!exists ){
             cuadrilleros.push(x)
           }
        }) */
        this.cuadrilleros = usuarios.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
        this.contratistaId = e.id
      }
    },
    selectCuadrillero(e){
       this.equipoId = null
       this.cuadrilleroId = null
       this.equipo = null
       this.equipos = []
       if( e != null){
         let equipos = []
         e.cuadrilla_.map(x => {
            equipos.push(x.equipo)
         })
         this.equipos = equipos.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
         this.cuadrilleroId = e.id
       }
    },
    selectEquipo(e){
       this.equipoId = null
       if( e != null){
         this.equipoId = e.id
       }
    },
    get(){
      ApiService.get("recoleccion").then(res => {
        this.contratistas = res.data.contratistas
        this.cuadros = res.data.cuadros
        this.matriz_materiales = res.data.matriz_materiales
        this.camiones = res.data.camiones
      });
    }
  },
};
</script>

<style>
.dashboard-i .card-body {
  padding: 0;
}
</style>
